"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitUnitDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var splitUnitDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createSplitUnit: _factoriesAny.createSplitUnit
};
exports.splitUnitDependencies = splitUnitDependencies;